import React, { useEffect, useState } from 'react';
import { useField } from 'react-final-form';

import { Select, SelectOption } from '../../Select';

import { combineValidators, required } from '../../../services/validators.service';
import { useTranslation } from 'react-i18next';
import { fetchIditIds } from '../iditMap';

export default function PreloadList({ categoryServiceUrl, value, defaultOption, label, validators = [], ...props }) {
    const [options, setOptions] = useState([]);
    const [hidden, setHidden] = useState(undefined);
    const { t } = useTranslation();
    const combinedValidations = combineValidators([required(t('empty_mandatory_error')), ...validators]);
    const { input, meta } = useField(props.name, { validate: combinedValidations });

    useEffect(() => {
        async function fetchOptions() {
            const serviceOptions = await fetch(`/media/${value?.toLowerCase()}.json`, {
                method: 'GET',
                headers: { Accept: 'application/json' }
            });
            const data = await serviceOptions.json();
            setOptions(data);
        }
        fetchOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const normalizedOptions = options.map(option => {
        return { description: option.kortkod, value: option.klarText };
    });
    const [iditIdsStstMap, setIditIdsStstMap] = useState(new Map());

    useEffect(() => {
        if (props?.fieldId === 'forbund') {
            const fetchIds = async () => {
                const iditIds = await fetchIditIds();
                setIditIdsStstMap(iditIds);
            };
            fetchIds();
        }
    }, []);

    const groupId = iditIdsStstMap?.get(hidden)?.groupId;
    const groupAgreementId = iditIdsStstMap?.get(hidden)?.groupAgreementId;

    const handleHidden = e => setHidden(e.target.value);
    return (
        normalizedOptions[0]?.description && (
            <>
                {hidden && iditIdsStstMap?.has(hidden) && (
                    <>
                        <input type="hidden" name="groupId" value={groupId} />
                        <input type="hidden" name="groupAgreementId" value={groupAgreementId}></input>
                    </>
                )}

                <Select
                    defaultValue={defaultOption ? defaultOption : normalizedOptions[0]?.description}
                    label={label}
                    {...input}
                    meta={meta}
                    onInput={label === 'Medlemskap' ? handleHidden : undefined}
                >
                    {defaultOption && (
                        <SelectOption disabled value={defaultOption}>
                            {defaultOption}
                        </SelectOption>
                    )}
                    {normalizedOptions.map((item, index) => {
                        return (
                            <SelectOption key={index} value={item.description}>
                                {item.value}
                            </SelectOption>
                        );
                    })}
                </Select>
            </>
        )
    );
    // return <InputControl {...props} options={normalizedOptions}></InputControl>;
}
